export default __webpack_public_path__ + "static/media/clock.229b5793.svg";